module.exports = __webpack_public_path__ + "static/media/aboutus.13078dc1.jpg";